import Badge, { type BadgeBorderVariant, type BadgeProps } from '@precis-digital/kurama/Badge'
import { type ThemeColor } from '@precis-digital/kurama/theme'
import { type ReactElement } from 'react'
import { isLineChartType, linePatternToBadgeShape } from '../constants'
import type { ChartType, LinePattern } from '../types'

export interface ChartBadgeProps {
  chartType?: ChartType
  color: ThemeColor
  pattern?: LinePattern
  variant?: BadgeBorderVariant
}

export const getChartBadgeProps = ({
  chartType,
  color,
  pattern = 'continuous',
  variant = 'lighter'
}: ChartBadgeProps): BadgeProps => {
  if (isLineChartType(chartType)) {
    return {
      color,
      variant,
      shape: linePatternToBadgeShape[pattern]
    }
  }

  return { color, variant }
}

const ChartBadge = (props: ChartBadgeProps): ReactElement => {
  return <Badge {...getChartBadgeProps(props)} />
}

export default ChartBadge
